import { Modal } from "@minervaproject/fds";

import { BookmarkForm } from "./bookmark_form";
import { BugReportForm } from "./bug_report_form";
import { KeyboardShortcuts } from "./keyboard_shortcuts";
import { KickOutWarning } from "./kick_out_warning";
import { PreclassCheck } from "./preclass_check";
import { Reactions } from "./reactions";
import { DetailedTalkTimeModal } from "./talk_time/detailed_talk_time_modal";

import { ModalErrorBoundary } from "components/error_boundary";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { LocalModalContentType } from "shared/types";
import { localSelectors } from "store";
import { hideLocalModal } from "store/reducers/local";

const DEFAULT_MODAL_STYLE = { zIndex: 1000 };

function LocalModal() {
  const dispatch = useAppDispatch();
  const modalContent = useAppSelector(localSelectors.selectLocalModalContent());

  const hideModal = () => dispatch(hideLocalModal());

  switch (modalContent) {
    case LocalModalContentType.AvPreferences:
      return <PreclassCheck buttonText="Return to Class" hideModal={hideModal} />;

    case LocalModalContentType.BookmarkForm:
      return (
        <ModalErrorBoundary text="The bookmark form cannot be displayed" hideModal={hideModal}>
          <Modal
            title="Bookmark This Moment"
            size="sm"
            onClose={hideModal}
            shouldCloseOnEsc
            style={DEFAULT_MODAL_STYLE}
          >
            <BookmarkForm hideModal={hideModal} />
          </Modal>
        </ModalErrorBoundary>
      );

    case LocalModalContentType.BugReportForm:
      return (
        <ModalErrorBoundary text="The bug report form cannot be displayed" hideModal={hideModal}>
          <Modal
            title="Bug Report"
            size="md"
            onClose={hideModal}
            shouldCloseOnEsc
            style={DEFAULT_MODAL_STYLE}
          >
            <BugReportForm hideModal={hideModal} />
          </Modal>
        </ModalErrorBoundary>
      );

    case LocalModalContentType.KeyboardShortcuts:
      return (
        <ModalErrorBoundary text="Keyboard shortcuts cannot be displayed" hideModal={hideModal}>
          <Modal
            title="Keyboard Shortcuts"
            size="md"
            onClose={hideModal}
            shouldCloseOnEsc
            style={DEFAULT_MODAL_STYLE}
          >
            <KeyboardShortcuts />
          </Modal>
        </ModalErrorBoundary>
      );

    case LocalModalContentType.KickOutWarning:
      return (
        <Modal size="sm" hideCloseButton style={DEFAULT_MODAL_STYLE}>
          <KickOutWarning hideModal={hideModal} />
        </Modal>
      );

    case LocalModalContentType.PreclassCheck:
      return <PreclassCheck buttonText="Enter Class" hideModal={hideModal} />;

    case LocalModalContentType.Reactions:
      return (
        <ModalErrorBoundary text="Reactions cannot be displayed" hideModal={hideModal}>
          <Modal
            title=""
            hideCloseButton
            onClose={hideModal}
            shouldCloseOnEsc
            style={DEFAULT_MODAL_STYLE}
            bgColor="transparent"
          >
            <Reactions hideModal={hideModal} />
          </Modal>
        </ModalErrorBoundary>
      );

    case LocalModalContentType.TalkTime:
      return (
        <ModalErrorBoundary text="Talk time cannot be displayed" hideModal={hideModal}>
          <Modal
            title="Talk Time"
            size="lg"
            onClose={hideModal}
            shouldCloseOnEsc
            style={DEFAULT_MODAL_STYLE}
          >
            <DetailedTalkTimeModal />
          </Modal>
        </ModalErrorBoundary>
      );

    default:
      return null;
  }
}

export { DEFAULT_MODAL_STYLE, LocalModal };
